import { Space, Table } from 'antd'
import HideOnMobile from '../../../../components/generic/hideOnMobile'
import Button from '@mui/material/Button'
import HeaderBox from '../../../../components/generic/arpariBoxes/headerBox'
import Stack from '@mui/material/Stack'
import { Empty } from 'antd'
import theme from '../../../../helpers/theme'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'

const bulkRequestCols = [
  {
    title: 'To/From',
    width: '40%',
  },
  {
    title: 'Instructions',
    width: '55%',
  },
]

const paymentReqsCols = [
  {
    title: 'Date',
    flex: 1,
  },
  {
    title: 'To/From',
    flex: 1,
  },
  {
    title: 'Description',
    flex: 2,
  },
  {
    title: 'Method',
    flex: 1,
  },
  {
    title: 'Amount',
    flex: 1,
  },
]

const columnsMap = {
  default: bulkRequestCols,
  paymentReqs: paymentReqsCols,
  approvals: paymentReqsCols,
}

const defaultHeaderActions = () => {
  return (
    <HideOnMobile>
      <Space>
        <Button
          sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
          disableElevation
          fullWidth
          size='small'
          type='submit'
          variant='outlined'
          color='secondary'
          disabled
        >
          Add Row
        </Button>
        <Button
          sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
          disableElevation
          fullWidth
          size='small'
          type='submit'
          variant='outlined'
          color='secondary'
          disabled
        >
          Upload Csv
        </Button>
      </Space>
    </HideOnMobile>
  )
}

const pendingRequestsHeaderActions = () => {
  return <></>
}

const approvalsHeaderActions = () => {
  return (
    <HideOnMobile>
      <FormControlLabel
        labelPlacement='start'
        label={
          <Typography color='secondary' sx={{ fontStyle: 'italic' }}>
            Requests I can approve
          </Typography>
        }
        control={
          <Switch
            sx={{
              '& .MuiSwitch-switchBase': {
                color: theme.palette.secondary.light,
              },
              '& .Mui-checked': {
                color: theme.palette.primary.main,
              },
            }}
            defaultChecked={false}
          />
        }
      />
    </HideOnMobile>
  )
}

const headerActionsMap = {
  default: defaultHeaderActions(),
  paymentReqs: pendingRequestsHeaderActions(),
  approvals: approvalsHeaderActions(),
}
const ComingSoonTab = ({ title, config = 'default' }) => {
  return (
    <Stack spacing={1}>
      <HeaderBox title={title} actions={headerActionsMap[config]} />
      <Table
        bordered
        dataSource={[]}
        columns={columnsMap[config]}
        pagination={false}
        tableLayout='fixed'
        locale={{ emptyText: <Empty description='Coming soon' image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
      />
      {config === 'default' && (
        <HideOnMobile>
          <Button
            disableElevation
            fullWidth
            size='small'
            type='submit'
            variant='contained'
            color='primary'
            sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
            htmlType='submit'
            style={{ marginTop: '18px', width: '100px' }}
            disabled
          >
            Submit
          </Button>
        </HideOnMobile>
      )}
    </Stack>
  )
}

export default ComingSoonTab
